import React from 'react';
import ExtLinksBase from './ExtLinks';

const ExtLinks = () => {
  return <ExtLinksBase />;
};

export default ExtLinks;
